
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getMunicipalitiesFromSlugs",
      resolverType: "query",
      routePath: "/getMunicipalitiesFromSlugs",
      httpMethod: "POST",
    });
  